export const pageMargin = '10px';
export const pageMarginTop = '100px';
export const pageMarginBottom = '300px';
export const fontSizep = '10px';
export const fontBold = 'Helvetica-Bold';
